import React, { useCallback, useEffect, useState } from 'react';
import { GoogleReCaptchaProvider, useGoogleReCaptcha } from 'react-google-recaptcha-v3';
import HTTP from '../axios';

// Single app-wide reCAPTCHA v3 provider; the site key is served by the backend.
export const RecaptchaProvider = ({ children }: { children: React.ReactNode }) => {
    const [siteKey, setSiteKey] = useState('');

    useEffect(() => {
        const getSiteKey = async () => {
            try {
                const response = await HTTP.get('/api/fetch-site-key');
                const { status, siteKey } = response.data;
                if (status && siteKey) {
                    setSiteKey(siteKey);
                }
            } catch (err) {
                console.log('Check Error from get site key', err);
            }
        };
        getSiteKey();
    }, []);

    return siteKey ? (
        <GoogleReCaptchaProvider reCaptchaKey={siteKey}>{children}</GoogleReCaptchaProvider>
    ) : (
        <>{children}</>
    );
};

// Returns a function that resolves to a reCAPTCHA token for the given action ('' if unavailable).
// Send it as `siteToken` in the request body of any public form submission.
export const useRecaptchaToken = () => {
    const { executeRecaptcha } = useGoogleReCaptcha();
    return useCallback(
        async (action: string): Promise<string> => (executeRecaptcha ? await executeRecaptcha(action) : ''),
        [executeRecaptcha]
    );
};

// True when an API error is a failed reCAPTCHA check (401 + recaptchaStatus 0).
export const isRecaptchaError = (error: any): boolean =>
    error?.response?.status === 401 && error?.response?.data?.recaptchaStatus === 0;
